var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { InstanceObserver } from '@progress/kendo-charts';
import { toDomEvent } from './../events/dom-event';
import { hasParent } from '../utils/main';
import { Popup } from '@progress/kendo-react-popup';
var COLLISION = { horizontal: 'fit', vertical: 'fit' };
var TOOLTIP_CLASS = 'k-chart-tooltip';
var POPUP_WRAPPER_CLASS = 'k-chart-tooltip-wrapper';
/**
 * @hidden
 */
var TooltipPopup = /** @class */ (function (_super) {
    __extends(TooltipPopup, _super);
    function TooltipPopup(props, context) {
        var _this = _super.call(this, props) || this;
        _this.onChartMouseLeave = function (e) {
            var syntheticEvent = e.syntheticEvent;
            if (hasParent(syntheticEvent.relatedTarget, _this.element)) {
                /* prevent default behavior so that the tooltip won't be hidden */
                return true;
            }
            return false;
        };
        _this.onMouseLeave = function (e) {
            var domEvent = toDomEvent(_this, e);
            var isDefaultPrevented = _this.context.childrenObserver.trigger('onMouseLeave', domEvent);
            if (isDefaultPrevented) {
                e.preventDefault();
            }
        };
        _this.chartObserver = new InstanceObserver(_this, {
            onMouseLeave: 'onChartMouseLeave'
        });
        context.observersStore.dispatch({
            type: 'add',
            payload: _this.chartObserver
        });
        return _this;
    }
    TooltipPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, popupShown = _a.popupShown, popupAlign = _a.popupAlign, popupOffset = _a.popupOffset, popupStyles = _a.popupStyles, popupContent = _a.popupContent, className = _a.className;
        var wrapperClass = [TOOLTIP_CLASS, className].join(' ').trim();
        var popupComponent = (React.createElement(Popup, { animate: false, popupAlign: popupAlign, offset: popupOffset, show: popupShown, collision: COLLISION, className: POPUP_WRAPPER_CLASS },
            React.createElement("div", { className: wrapperClass, style: popupStyles, onMouseLeave: this.onMouseLeave, ref: function (el) { return _this.element = el; } }, popupContent())));
        return popupComponent;
    };
    TooltipPopup.prototype.componentWillUnmount = function () {
        this.context.observersStore.dispatch({
            type: 'remove',
            payload: this.chartObserver
        });
    };
    TooltipPopup.contextTypes = {
        observersStore: PropTypes.object,
        childrenObserver: PropTypes.object
    };
    return TooltipPopup;
}(React.Component));
export { TooltipPopup };
//# sourceMappingURL=Popup.js.map